export default __webpack_public_path__ + "img/745312216c4c62f58ee6790429263412.svg";